import { Diagnostic } from "@siteimprove/alfa-act";
import { Map } from "@siteimprove/alfa-map";
/**
 * @public
 */
export class MatchingClasses extends Diagnostic {
    static of(message, matchingTargets = Map.empty(), matchingNonTargets = Map.empty()) {
        return new MatchingClasses(message, matchingTargets, matchingNonTargets);
    }
    _matchingTargets;
    _matchingNonTargets;
    constructor(message, matchingTargets, matchingNonTargets) {
        super(message);
        this._matchingTargets = matchingTargets;
        this._matchingNonTargets = matchingNonTargets;
    }
    get matchingTargets() {
        return this._matchingTargets;
    }
    get matchingNonTargets() {
        return this._matchingNonTargets;
    }
    equals(value) {
        return (value instanceof MatchingClasses &&
            value._matchingTargets.equals(this._matchingTargets) &&
            value._matchingNonTargets.equals(this._matchingNonTargets));
    }
    hash(hash) {
        super.hash(hash);
        this._matchingTargets.hash(hash);
        this._matchingNonTargets.hash(hash);
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            matchingTargets: this._matchingTargets.toJSON(options),
            matchingNonTargets: this._matchingNonTargets.toJSON(options),
        };
    }
}
/**
 * @public
 */
(function (MatchingClasses) {
    /**@public */
    function isMatchingClasses(value) {
        return value instanceof MatchingClasses;
    }
    MatchingClasses.isMatchingClasses = isMatchingClasses;
})(MatchingClasses || (MatchingClasses = {}));
//# sourceMappingURL=diagnostics.js.map